import {
  CARE_HISTORY_LABEL,
  type LabWebdocAssessmentResult,
} from "@care-by-ella/contracts";

// TES-1060 / TES-1347 — what the doctor is told after "Hantera provsvar från
// Webdoc": where the assessment went, and (TES-1347, Ö-295) what became of
// his patient feedback. The server decides; this only says it.
// On a box with the notice off (prod today) the line is the one it always
// was.
const SAVED =
  "Provbedömningen är registrerad och sparad i kompletteringsanteckningen.";
const HELD =
  "Provbedömningen är sparad i utkastet till kompletteringsanteckningen. Den hålls tills alla kompletteringar är klara.";

export function labWebdocDoneNotice(
  result: Pick<LabWebdocAssessmentResult, "held" | "feedbackNotice">,
): string {
  if (result.held) return HELD;
  switch (result.feedbackNotice) {
    case "published":
      return `${SAVED} Återkopplingen är publicerad för patienten som ”${CARE_HISTORY_LABEL.lab_feedback}” under Din vård.`;
    case "in_decision":
      return `${SAVED} Återkopplingen publiceras inte separat: patienten får ett sammanhållet besked med behandlingsbeslutet. Ta med det hon behöver veta om provsvaret i läkarens kommentar.`;
    case "already_published":
      return `${SAVED} Patienten har redan fått läkarens besked om det här provsvaret, så återkopplingen publicerades inte igen.`;
    default:
      return SAVED;
  }
}
